import React from 'react';
import { useEnvironment } from 'context/EnvironmentContext/EnvironmentContext';
import { Box, Flex, Text } from '@applatform/design-system';
import Container from 'components/V1/Container/Container';
import Icon from 'components/V1/Icon/Icon';
import UserMenu from '../UserMenu/UserMenu';
import AvatarButton from './AvatarButton/AvatarButton';
import { ReactComponent as UserIcon } from 'icons/user.svg';

interface TopBarProps {
  mobileNavButton: React.ReactNode;
}

function TopBar({ mobileNavButton }: TopBarProps) {
  const { environment } = useEnvironment();

  return (
    <Container
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '100%',
        p: '$6',
        '@md': {
          justifyContent: 'flex-end',
        },
        '@lg': {
          px: '$20',
          py: '$10',
        },
      }}
    >
      {mobileNavButton}
      <Flex css={{ alignItems: 'center' }}>
        {environment === 'pre-live' && (
          <Box
            css={{
              position: 'relative',
              display: 'inline-block',
              mr: '$6',
            }}
          >
            <Box
              role="presentation"
              css={{
                position: 'absolute',
                backgroundColor: '$red500',
                height: '12px',
                width: '100%',
                top: '50%',
              }}
            />
            <Text
              size="md"
              css={{
                position: 'relative',
                px: '$1',
                fontWeight: '$bold',
                textTransform: 'uppercase',
              }}
            >
              Pre-live
            </Text>
          </Box>
        )}
        <UserMenu
          trigger={
            <AvatarButton aria-label="user menu">
              <Icon as={UserIcon} />
            </AvatarButton>
          }
        />
      </Flex>
    </Container>
  );
}

export default TopBar;
